export const URL = window.tom && window.tom.conf.url;
export const SSL_URL = window.tom && window.tom.conf.sslUrl;
export const PATH = {
  RESIZE: window.tom && window.tom.conf.path.resize,
  STATIC: window.tom && window.tom.conf.path.static
};

// 言語コード
export const LANG_CODES = {
  EN: 'en',
  JA: 'ja'
};

// 国コード
export const COUNTRY_CODES = {
  US: 'us',
  JP: 'jp'
};

// 言語+国ロケールコード
export const LANG_COUNTRY_CODES = {
  EN_US: 'en_us',
  JA_JP: 'ja_jp'
};
